import { useLocation } from 'react-router-dom';
import { appConfig } from '../lib/config.js';

const HIDDEN_PATHS = new Set(['/onboarding', '/login', '/auth/callback']);

export default function CrossAppBar() {
  const { pathname } = useLocation();

  if (HIDDEN_PATHS.has(pathname)) return null;
  if (!appConfig.intervieweeAppUrl) return null;

  return (
    <aside
      role="banner"
      aria-label="Cross-app announcement"
      className="crossapp-slide-in sticky top-0 z-50 w-full border-t border-obsidian-50/30 bg-obsidian-400"
    >
      <div className="relative flex h-11 items-center justify-center px-4 sm:h-12 sm:px-6">
        <a
          href={appConfig.intervieweeAppUrl}
          target="_self"
          className="flex min-w-0 flex-1 items-center justify-center gap-2 text-[13px] font-medium sm:text-[14px]"
          style={{ fontFamily: 'var(--font-sans)' }}
        >
          <svg
            className="h-4 w-4 shrink-0 text-amber-400"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M9 9h4.5a2 2 0 0 1 0 4H10a2 2 0 0 0 0 4h5" />
            <path d="M12 6v2M12 16v2" />
          </svg>
          <span className="whitespace-nowrap font-bold text-amber-400">
            Get Paid for Your Expertise
          </span>
          <span className="truncate text-amber-100/80">
            &#8594; paid interviews up to $300+
          </span>
          <span aria-hidden="true" className="hidden text-amber-400 sm:inline">
            &#8594;
          </span>
        </a>
      </div>
    </aside>
  );
}
